//  Logo is 100px x 100px by default, but can be scaled up or down.
const LOGO_BASE_WIDTH = 100;
const LOGO_BASE_HEIGHT = 100;
const LOGO_SIZE_RATIO = LOGO_BASE_WIDTH / LOGO_BASE_HEIGHT; // 1

type FOSSALogoProps = {
  width?: number;
};

/**
 * Just the FOSSA Cat Glyph icon in black and white
 *
 * @param {FOSSALogoProps} props - FOSSALogo props
 * @param {number} [props.width] - Width for the logo.
 */
const FOSSAGlyph = ({
  width,
}: FOSSALogoProps) => (
  <svg
    fill="none"
    width={width || '100%'}
    height={width ? (width / LOGO_SIZE_RATIO) : undefined}
    viewBox={`0 0 ${LOGO_BASE_WIDTH} ${LOGO_BASE_HEIGHT}`}
    >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      fill="white"
      d="M5.81193 40.2983C3.73079 35.6821 5.78588 30.253 10.402 28.1719L57.7809 6.81193C62.397 4.73079 67.8261 6.78588 69.9072 11.402L91.2673 58.7809C93.3484 63.3971 91.2933 68.8262 86.677 70.9073L39.2984 92.2671C34.682 94.3485 29.2529 92.2931 27.1719 87.6771L5.81193 40.2983Z"
    />
    <path
      fill="black"
      d="M7.6352 39.4762C6.00805 35.8671 7.61481 31.6223 11.224 29.9952L58.6029 8.6352C62.212 7.00805 66.4568 8.61481 68.0839 12.224L89.444 59.6029C91.0711 63.2121 89.4644 67.4568 85.855 69.084L38.4764 90.4438C34.867 92.0712 30.6223 90.4642 28.9951 86.8551L7.6352 39.4762Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      fill="white"
      d="M15.1944 27.6471C16.0927 19.6949 22.5584 13.4595 30.4806 13.4595C33.9359 13.4595 37.1236 14.6506 39.6876 16.6548C40.2656 17.1065 40.8116 17.5994 41.322 18.1292C42.0226 18.8308 43.0654 19.2728 45.3257 19.5033C47.6002 19.7352 50.8823 19.7366 55.8886 19.7366C63.0724 19.7366 69.6373 22.2161 75.0272 26.293C75.2814 26.4854 75.5121 26.6922 75.7242 26.9019C76.0618 27.2356 76.3686 27.593 76.6448 27.915L76.6495 27.9204C76.7602 28.0494 76.8661 28.1726 76.9726 28.2934C78.2491 29.7429 80.5758 31.2495 83.5269 32.4847C86.4572 33.7113 89.9127 34.6323 93.367 34.9694L94.2699 35.0576V45.034L94.2465 45.1401C93.1172 50.2757 90.97 53.5599 88.3851 56.3202C87.0753 57.7187 85.5522 58.9748 83.7988 60.2572L83.7722 60.2767L83.7443 60.2944C82.4505 61.1154 80.9145 61.361 79.4617 61.1432C74.8556 60.4524 71.2288 60.2621 68.8899 60.2621C58.7287 60.2621 50.0205 63.0752 43.7331 68.192C37.4606 73.2968 33.5262 80.75 32.9799 90.1977L32.8869 91.8052L31.4872 91.0092C30.0355 90.1837 28.8219 88.9059 28.0837 87.2681L6.72381 39.8894C6.10996 38.5279 5.89969 37.084 6.04378 35.6955L6.11944 34.9665L15.5789 33.0252C15.2824 31.8527 15.0874 30.6531 15.0874 29.5541C15.0874 28.9092 15.1237 28.2728 15.1944 27.6471Z"
    />
    <path
      fill="black"
      d="M17.2708 27.2173C18.3329 20.5103 23.8766 15.4595 30.4807 15.4595C33.1094 15.4595 34.9375 19.175 35.9375 23.375C36.9375 27.575 38.6667 30.1979 39.4062 30.9844C30.8749 31.3097 26.0904 31.6374 17.5621 32.71L17.5178 32.5347C17.2461 31.46 17.0872 30.4338 17.0872 29.5542C17.0872 28.9845 17.1196 28.4228 17.1819 27.8716L17.2708 27.2173Z"
    />
    <path
      fill="black"
      d="M93.3059 44.9243C93.3059 44.9243 95.5989 44.4817 94.8489 37.6573C94.7369 36.6384 94.0993 35.8362 93.3059 35.7162C92.9632 35.6644 92.6277 35.6277 92.3313 35.6277C90.6964 35.6277 90.0085 35.7772 89.0817 36.6842L86.5762 39.1252C86.3421 39.3533 86.3518 39.7329 86.5976 39.9486C89.6985 42.6703 92.4213 44.9243 93.3059 44.9243Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      fill="white"
      d="M92.5152 45.7489C92.728 45.8352 93.0069 45.9243 93.3058 45.9243C93.5099 45.9243 93.7113 45.8518 93.7865 45.8155C93.9165 45.7615 94.0727 45.6796 94.2414 45.5567C94.5834 45.3074 94.9478 44.9107 95.2539 44.2954C95.8556 43.0861 96.2276 41.0475 95.843 37.548C95.6996 36.244 94.8429 34.9373 93.4553 34.7275C93.0935 34.6727 92.7011 34.6277 92.3312 34.6277C91.5071 34.6277 90.7951 34.6615 90.148 34.8597C89.5105 35.0549 89.0016 35.3878 88.5 35.8568L85.8784 38.409C85.227 39.0436 85.2536 40.0996 85.9379 40.7002C87.4895 42.0621 88.967 43.3251 90.1744 44.2507C90.7765 44.7123 91.3327 45.1064 91.8105 45.3898C92.0493 45.5313 92.2873 45.6566 92.5152 45.7489ZM92.8306 43.6694C92.964 43.7486 93.075 43.8077 93.1647 43.8503C93.244 43.768 93.3513 43.6297 93.4634 43.4045C93.8207 42.6863 94.2203 41.0916 93.8549 37.7666C93.7743 37.0328 93.3556 36.7351 93.1563 36.705C92.8328 36.656 92.5542 36.6277 92.3313 36.6277C91.5205 36.6277 91.0712 36.6686 90.7338 36.772C90.4372 36.8628 90.1672 37.0211 89.7811 37.3989L89.7795 37.4005L87.6144 39.5099C89.0266 40.7442 90.3298 41.8498 91.3912 42.6635C91.9681 43.1057 92.4523 43.4451 92.8306 43.6694Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      fill="black"
      d="M69.9097 36.1247C71.299 36.0572 72.3878 35.0583 72.4361 33.854L72.4348 33.8556C72.4907 32.4612 71.1528 31.3837 69.5744 31.4604C68.2628 31.5243 68.1127 31.5485 63.9636 32.5402C63.7118 32.6004 63.6425 32.8891 63.8475 33.0295C68.4488 36.196 68.5202 36.1925 69.9097 36.1247Z"
    />
  </svg>
);

export default FOSSAGlyph;
